import card_2_spades from './files/cards/card_2-spades.svg'
import card_2_clubs from './files/cards/card_2-clubs.svg'
import card_2_diamonds from './files/cards/card_2-diamonds.svg'
import card_2_hearts from './files/cards/card_2-hearts.svg'
import card_3_clubs from './files/cards/card_3-clubs.svg'
import card_3_diamonds from './files/cards/card_3-diamonds.svg'
import card_3_hearts from './files/cards/card_3-hearts.svg'
import card_3_spades from './files/cards/card_3-spades.svg'
import card_4_clubs from './files/cards/card_4-clubs.svg'
import card_4_diamonds from './files/cards/card_4-diamonds.svg'
import card_4_hearts from './files/cards/card_4-hearts.svg'
import card_4_spades from './files/cards/card_4-spades.svg'
import card_5_clubs from './files/cards/card_5-clubs.svg'
import card_5_diamonds from './files/cards/card_5-diamonds.svg'
import card_5_hearts from './files/cards/card_5-hearts.svg'
import card_5_spades from './files/cards/card_5-spades.svg'
import card_6_clubs from './files/cards/card_6-clubs.svg'
import card_6_diamonds from './files/cards/card_6-diamonds.svg'
import card_6_hearts from './files/cards/card_6-hearts.svg'
import card_6_spades from './files/cards/card_6-spades.svg'
import card_7_clubs from './files/cards/card_7-clubs.svg'
import card_7_diamonds from './files/cards/card_7-diamonds.svg'
import card_7_hearts from './files/cards/card_7-hearts.svg'
import card_7_spades from './files/cards/card_7-spades.svg'
import card_8_clubs from './files/cards/card_8-clubs.svg'
import card_8_diamonds from './files/cards/card_8-diamonds.svg'
import card_8_hearts from './files/cards/card_8-hearts.svg'
import card_8_spades from './files/cards/card_8-spades.svg'
import card_9_clubs from './files/cards/card_9-clubs.svg'
import card_9_diamonds from './files/cards/card_9-diamonds.svg'
import card_9_hearts from './files/cards/card_9-hearts.svg'
import card_9_spades from './files/cards/card_9-spades.svg'
import card_10_clubs from './files/cards/card_10-clubs.svg'
import card_10_diamonds from './files/cards/card_10-diamonds.svg'
import card_10_hearts from './files/cards/card_10-hearts.svg'
import card_10_spades from './files/cards/card_10-spades.svg'
import card_ace_clubs from './files/cards/card_ace-clubs.svg'
import card_ace_diamonds from './files/cards/card_ace-diamonds.svg'
import card_ace_hearts from './files/cards/card_ace-hearts.svg'
import card_ace_spades from './files/cards/card_ace-spades.svg'
import card__back from './files/cards/card_back.svg'
import card_jack_clubs from './files/cards/card_jack-clubs.svg'
import card_jack_diamonds from './files/cards/card_jack-diamonds.svg'
import card_jack_hearts from './files/cards/card_jack-hearts.svg'
import card_jack_spades from './files/cards/card_jack-spades.svg'
import card_joker from './files/cards/card_joker.svg'
import card_king_clubs from './files/cards/card_king-clubs.svg'
import card_king_diamonds from './files/cards/card_king-diamonds.svg'
import card_king_hearts from './files/cards/card_king-hearts.svg'
import card_king_spades from './files/cards/card_king-spades.svg'
import card_queen_clubs from './files/cards/card_queen-clubs.svg'
import card_queen_diamonds from './files/cards/card_queen-diamonds.svg'
import card_queen_hearts from './files/cards/card_queen-hearts.svg'
import card_queen_spades from './files/cards/card_queen-spades.svg'

export const cards = {
  card_2_spades,
  card_2_clubs,
  card_2_diamonds,
  card_2_hearts,
  card_3_clubs,
  card_3_diamonds,
  card_3_hearts,
  card_3_spades,
  card_4_clubs,
  card_4_diamonds,
  card_4_hearts,
  card_4_spades,
  card_5_clubs,
  card_5_diamonds,
  card_5_hearts,
  card_5_spades,
  card_6_clubs,
  card_6_diamonds,
  card_6_hearts,
  card_6_spades,
  card_7_clubs,
  card_7_diamonds,
  card_7_hearts,
  card_7_spades,
  card_8_clubs,
  card_8_diamonds,
  card_8_hearts,
  card_8_spades,
  card_9_clubs,
  card_9_diamonds,
  card_9_hearts,
  card_9_spades,
  card_10_clubs,
  card_10_diamonds,
  card_10_hearts,
  card_10_spades,
  card_ace_clubs,
  card_ace_diamonds,
  card_ace_hearts,
  card_ace_spades,
  card__back,
  card_jack_clubs,
  card_jack_diamonds,
  card_jack_hearts,
  card_jack_spades,
  card_joker,
  card_king_clubs,
  card_king_diamonds,
  card_king_hearts,
  card_king_spades,
  card_queen_clubs,
  card_queen_diamonds,
  card_queen_hearts,
  card_queen_spades,
}
